import { IReduxAction } from "@/views/interfaces";
import { GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_SUCCESS } from "../actions";
import { updateState } from "@/utils/reduxUtils";

const initialState = {
  L12M: null,
  L30D: null,
  N30D: null,
};

export const reservationDistributionReducer = (
  state = initialState,
  { type, payload }: IReduxAction
) => {
  switch (type) {
    case GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_SUCCESS: {
      return updateState(state, payload);
    }
    default:
      return state;
  }
};
